import React, { useEffect, useState } from "react";
import { fetchAdmins, fetchUsers, toggleUserActive } from "../services/api"; 
import { useNavigate } from "react-router-dom";

function AdminList() {
  const [admins, setAdmins] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Get the logged-in user's role
  const userRole = sessionStorage.getItem("userRole");

  useEffect(() => {
  const loadData = async () => {
    try {
      setLoading(true);

      if (userRole === "super_admin") {
        const adminResponse = await fetchAdmins();
        setAdmins(adminResponse);
      }

      const userResponse = await fetchUsers();
      setUsers(userResponse);

      setLoading(false);
    } catch (err) {
      setError("Failed to fetch data.");
      setLoading(false);
    }
  };

  loadData();
}, [userRole]);

  // useEffect(() => {
  //   loadData();
  // }, []);

  // const loadData = async () => {
  //   try {
  //     setLoading(true);

  //     if (userRole === "super_admin") {
  //       const adminResponse = await fetchAdmins();
  //       setAdmins(adminResponse);
  //     }

  //     const userResponse = await fetchUsers();
  //     setUsers(userResponse);

  //     setLoading(false);
  //   } catch (err) {
  //     setError("Failed to fetch data.");
  //     setLoading(false);
  //   }
  // };

  const handleToggleActive = async (userId, isAdmin) => {
    try {
      await toggleUserActive(userId);
      
      if (isAdmin) {
        setAdmins(
          admins.map((admin) =>
            admin._id === userId ? { ...admin, active: !admin.active } : admin
          )
        );
      } else {
        setUsers(
          users.map((user) =>
            user._id === userId ? { ...user, active: !user.active } : user
          )
        );
      }
    } catch (err) {
      setError("Failed to update status.");
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Admin & User List</h2>
      {error && <p style={styles.error}>{error}</p>}

      {userRole === "super_admin" && (
        <button style={styles.addButton} onClick={() => navigate("/add-admin")}>
          + Click Here for Adding
        </button>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {/* Admin List (Only for Super Admin) */}
          {userRole === "super_admin" && (
            <div>
              <h3 style={styles.sectionTitle}>Admin List</h3>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Email</th>
                    <th style={styles.th}>Status</th>
                    <th style={styles.th}>Project</th>
                    <th style={styles.th}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {admins.map((admin) => (
                    <tr key={admin._id}>
                      <td style={styles.td}>{admin.email}</td>
                      <td style={styles.td}>{admin.active ? "Active" : "Inactive"}</td>
                       <td style={styles.td}>{admin.project}</td>
                      <td style={styles.td}>
                        <button
                          style={admin.active ? styles.activeButton : styles.inactiveButton}
                          onClick={() => handleToggleActive(admin._id, true)}
                        >
                          {admin.active ? "Deactivate" : "Activate"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* User List (Visible to both Admins and Super Admins) */}
          <div>
            <h3 style={styles.sectionTitle}>User List</h3>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Email</th>
                  <th style={styles.th}>Status</th>
                  <th style={styles.th}>Project</th>
                  <th style={styles.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user._id}>
                    <td style={styles.td}>{user.email}</td>
                    <td style={styles.td}>{user.active ? "Active" : "Inactive"}</td>
                    <td style={styles.td}>{user.project}</td>
                    <td style={styles.td}>
                      <button
                        style={user.active ? styles.activeButton : styles.inactiveButton}
                        onClick={() => handleToggleActive(user._id, false)}
                      >
                        {user.active ? "Deactivate" : "Activate"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
    maxWidth: "800px",
    margin: "50px auto",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  title: {
    fontSize: "24px",
    marginBottom: "10px",
  },
  addButton: {
    padding: "10px",
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginBottom: "20px",
  },
  sectionTitle: {
    fontSize: "20px",
    marginTop: "20px",
    textAlign: "left",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
  },
  th: {
    backgroundColor: "#007bff",
    color: "#fff",
    padding: "10px",
    borderBottom: "2px solid #ddd",
  },
  td: {
    padding: "10px",
    borderBottom: "1px solid #ddd",
  },
  activeButton: {
    backgroundColor: "green",
    color: "#fff",
    padding: "5px 10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  inactiveButton: {
    backgroundColor: "gray",
    color: "#fff",
    padding: "5px 10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  error: {
    color: "red",
  },
};

export default AdminList;
